export default [
  {
    key: 'courier_id',
    label: 'Kurir',
    type: 'select',
    actionSearch: 'courier/fetchSelection',
    text: 'name',
    optionKey: 'id',
    required: true,
  },
  {
    key: 'code',
    label: 'Kode',
    type: 'text',
    required: true,
  },
  {
    key: 'name',
    label: 'Nama Layanan',
    type: 'text',
    required: true,
  },
  {
    key: 'category',
    label: 'Kategori',
    type: 'select',
    options: [
      { value: 'economy', text: 'Economy' },
      { value: 'regular', text: 'Regular' },
      { value: 'nextday', text: 'Nextday' },
      { value: 'sameday', text: 'Sameday' },
      { value: 'cargo', text: 'Cargo' },
      { value: 'document', text: 'Document' },
    ],
    required: true,
  },
  {
    key: 'enabled',
    label: 'Status',
    type: 'radio',
    value: true,
    options: [
      { value: true, text: 'Aktif' },
      { value: false, text: 'Tidak Aktif' },
    ],
  },
]
